import React from 'react';
import {createStore} from "redux";
import ReactDOM from 'react-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'antd/dist/antd.less';  
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.css'
import App from './App';
import middleware from './redux/middleware';
import {Provider} from "react-redux"
import Loader from './components/loader/Loader'
import * as serviceWorker from './serviceWorker';
import combineReducers from './redux/reducers/index';
import './firebase';

export const store = createStore(combineReducers, middleware);

ReactDOM.render(
  <Provider store={store}>
      <App />
      <Loader/>
  </Provider>, 
  document.getElementById('root')
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
